export default /* html */`
<main class="container">
  <nav class="side_nav" *bind:aria-expanded="isSideNavOpen ? true : false">
    <div class="side_nav__buttons">
      <ui-icon-button aria-label="File explorer" @click="toggleSideNav"><ui-icon *bind:icon="iconFolder"></ui-icon></ui-icon-button>
    </div>
    <div class="side_nav__contents">
      <div class="explorer" @click="handleProgramChange">
        <div class="explorer__header">
          <span>Explorer</span>
        </div>
        <button
          *for="program of programs"
          *bind:data-program="program.value"
          *bind:aria-pressed="program.value === programName"
          >{{program.label}}</button>
      </div>
    </div>
  </nav>
  <div class="content">
    <div class="top_bar">
      <nav class="controls">
        <ui-icon-button aria-label="Compile" title="Compile" @click="compile" *bind:disabled="!isRunning && !isStepping ? null : true"><ui-icon icon="build_circle"></ui-icon></ui-icon-button>
        <ui-icon-button aria-label="Start" title="Start" @click="run" *bind:disabled="!isRunning && !isStepping && isCompiled ? null : true"><ui-icon icon="play_circle"></ui-icon></ui-icon-button>
        <ui-icon-button aria-label="Step" title="Step" @click="step" *bind:disabled="isCompiled && !isRunning ? null : true"><ui-icon icon="step"></ui-icon></ui-icon-button>
        <ui-icon-button aria-label="Exit" title="Exit" @click="exit" *bind:disabled="isCompiled ? null : true"><ui-icon icon="cancel"></ui-icon></ui-icon-button>
      </nav>
      <div class="cpu_status">
        <span>Status CPU</span> <span class="cpu_indicator" *bind:data-is-running="isRunning">{{ isRunning ? 'on' : 'off' }}</span>
      </div>
      <!-- <div class="program_dropdown">
        <label for="programName">Program</label>
        <div class="select__wrapper">
          <select
            id="programName"
            name="programName"
            @change="handleProgramChange"
            *model="programName"
            *bind:disabled="isRunning ? '' : null">
            <option *for="program of programs" *bind:value="program.value">{{program.label}}</option>
          </select>
        </div>
      </div> -->
      <ui-icon-button
        slot="trailing-icon"
        @click="handleColorSchemeChange"
      >
        <ui-icon *bind:icon="colorSchemeIcon"></ui-icon>
      </ui-icon-button>
    </div>
    <div class="code">
      <div class="left">
        <nav class="tabs">
          <button class="tab" *bind:aria-pressed="tab === 1" @click="handleTabChange(1)"><span>Editor</span> <ui-icon icon="code"></ui-icon></button>
          <button class="tab" *bind:aria-pressed="tab === 2" @click="handleTabChange(2)"><span>Memory</span> <ui-icon icon="memory"></ui-icon></button>
        </nav>
        <div class="content_wrapper">
          <div class="input" *if="tab === 1">
            <code-editor
              *ref="codeEditor"
              *bind:theme="colorScheme"
            ></code-editor>
          </div>
          <table class="memory__table" *if="tab === 2">
            <thead class="memory__header">
              <tr class="memory__row">
                <td><span>Address</span></td>
                <td><span>Contents</span></td>
                <td><span>ASCII</span></td>
              </tr>
            </thead>
            <tbody class="memory" *ref="memory">
              <tr *for="entry of memory" class="memory__row">
                <td><span class="memory__address">{{entry.address}}</span></td>
                <td><span class="memory__contents">{{entry.contents}}</span></td>
                <td><span class="memory__ascii">{{entry.ascii}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="right">
        <div class="section_label">
          <span>Registers</span><ui-icon icon="hard_drive_2"></ui-icon>
        </div>
        <div class="content_wrapper registers__container">
          <div class="registers" *ref="output">
            <div class="register__row" *for="register of registers">
              <span class="register__name">{{register.name}}</span>
              <span class="register__contents">{{register.contents}}</span>
              <span class="register__ascii">{{register.ascii}}</span>
            </div>
          </div>
        </div>
        <div class="section_label">
          <span>Console</span> <ui-icon icon="terminal"></ui-icon>
        </div>
        <div class="content_wrapper">
          <div class="console">
            <div *for="log of logs"><span>{{log}}</span></span></div>
          </div>
        </div>
        <div class="section_label">
          <span>Pixel buffer</span> <ui-icon icon="terminal"></ui-icon> <span>c8000000</span>
        </div>
        <div class="content_wrapper">
          <div class="pixel_buffer">
            <canvas *ref="pixelBuffer" width="320" height="240">VGA pixel buffer</canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>`